import React, {useContext, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, RemoveClientPortalSign} from "../CommonComponents/Routes";

const EstimateJobCharges = () => { //this component has details about estimate job charges
    let RecordsController = useContext(RecordsManagementContext)
    let EstimateDetails = RecordsController.CP_PageDetails.EstimateDetails
    const [SignPresent, setSignPresent] = useState(true)
    let loadingImage = <img src={process.env.PUBLIC_URL + "/Images/Loader18.gif"} alt=""/>
    let loading = localStorage.getItem("loading")
    let jobDetails = EstimateDetails.JobDetails.JobDetails == undefined ? EstimateDetails.JobDetails : EstimateDetails.JobDetails.JobDetails
    let isAdmin = EstimateDetails.JobDetails.isAdmin

    let image = jobDetails.EstClientPortalSignature !== null ?
        <img src={jobDetails.EstClientPortalSignature} alt=""/> : ''

    let signText = jobDetails.EstClientPortalSignature !== null ?
        <li><span
            className="moving-estimate">By signing the estimate electronically, you are agreeing to
            {` ${jobDetails.CompanyBranchName}`} Terms and conditions stated herein.</span>
        </li> : ''

    const DeleteSign = (img_id) => {//used to delete the estimate signature
        RecordsController.setSignatureButtonShown(true)
        let cookie = document.cookie.split('employee_id=')[1]//check if the employee is admin or not
        let Data = {estimate_key: Elink, employee_key: cookie, sign_id: img_id}
        axios({method: 'post', url: RemoveClientPortalSign, data: Data}).then((response) => {//request is sent to "remove_client_portal_sign" function  delete the sign
            {
                RecordsController.SetCP_PageDetails({
                    ...RecordsController.CP_PageDetails,
                    ClientPortalHeader: {
                        ...RecordsController.CP_PageDetails.ClientPortalHeader,
                        PortalSignature: {
                            ...RecordsController.CP_PageDetails.ClientPortalHeader.PortalSignature,
                            IsSignaturePresent: response.data[1].IsSignaturePresent
                        }
                    },
                    EstimateDetails: {
                        ...RecordsController.CP_PageDetails.EstimateDetails,
                        JobDetails: {
                            ...RecordsController.CP_PageDetails.EstimateDetails.JobDetails,
                            JobDetails: {
                                ...RecordsController.CP_PageDetails.EstimateDetails.JobDetails.JobDetails,
                                ClientPortalSignId: response.data[0].JobDetails.ClientPortalSignId,
                                ClientPortalSignatureUpdatedAt: response.data[0].JobDetails.ClientPortalSignatureUpdatedAt,
                                EstClientPortalSignature: response.data[0].JobDetails.EstClientPortalSignature,
                                ShowSign: response.data[0].JobDetails.ShowSign,
                                EventExist: response.data[0].JobDetails.EventExist,
                                isAdmin: response.data[0].JobDetails.isAdmin
                            }
                        }
                    }
                })
                setSignPresent(true)
                localStorage.setItem("loading", "no") //to hide the loader the loading value is set to "no"
            }
        })
    }
    if (useContext(RecordsManagementContext).IsJobOpen) {
        return (<div className="col-sm-6">
            {SignPresent === true ?
                <div className={loading == 'yes' ? "estimated-date-new" : "estimated-date"}>
                    {image ?
                        <> {isAdmin ?
                            <div className='btn client_portal_sign'
                                 onClick={() =>
                                     DeleteSign(jobDetails.ClientPortalSignId,
                                         setSignPresent(false))}>
                                X
                            </div> : <></>}
                            {image}
                            <div className="estimated-date2">{jobDetails.ClientPortalSignatureUpdatedAt}</div>
                        </> : loading == "yes" ? loadingImage : ""}
                </div> : <></>
            }
        </div>)
    } else {


        return (
            <>
                <li><h6>Estimated Job Charges</h6></li>
                <li>
                    <table className="table estimated-cost-tbl description">
                        <thead>
                        <tr>
                            <th scope="col">Charge Description</th>
                            <th scope="col">Charge Rate</th>
                            <th scope="col">Charge Cost</th>
                        </tr>
                        </thead>
                        <tbody>
                        <Charges Charge={EstimateDetails.Truck}/>
                        <Charges Charge={EstimateDetails.CrewSize}/>
                        <Charges Charge={EstimateDetails.BaseFee}/>
                        <Charges Charge={EstimateDetails.MinHours}/>
                        <Charges Charge={EstimateDetails.MaxHours}/>
                        {/*<Charges Charge={EstimateDetails.EstimatedHours}/>*/}
                        {/*<Charges Charge={EstimateDetails.MovingHours}/>*/}
                        {/*<Charges Charge={EstimateDetails.TravelTime}/>*/}
                        {(EstimateDetails.EstimateType === "hourly" || EstimateDetails.EstimateType === "not_to_exceed")
                        && EstimateDetails.ShowHourlyRates ?
                            <Charges Charge={EstimateDetails.MovingFee} ChargeRate={EstimateDetails.HourlyRate}/> :
                            <Charges Charge={EstimateDetails.MovingFee}/>}
                        {(EstimateDetails.EstimateType === "hourly" || EstimateDetails.EstimateType === "not_to_exceed")
                        && EstimateDetails.ShowHourlyRates ?
                            <Charges Charge={EstimateDetails.TravelFee} ChargeRate={EstimateDetails.HourlyRate}/> :
                            <Charges Charge={EstimateDetails.TravelFee}/>}
                        <Charges Charge={EstimateDetails.TruckAndEquipmentFee}/>
                        <Charges Charge={EstimateDetails.PackingMaterials}/>
                        <Charges Charge={EstimateDetails.PackingCrewSize}/>
                        {/*{EstimateDetails.EstimateType ==="hourly" ?*/}
                        {EstimateDetails.ShowPackingHourlyRate ?
                            <Charges Charge={EstimateDetails.PackingFee} ChargeRate={EstimateDetails.PackingHourlyRate}/>
                            :  <Charges Charge={EstimateDetails.PackingFee}/> }
                        {/*<Charges Charge={EstimateDetails.PackingFee} />}*/}
                        {/*<Charges Charge={EstimateDetails.PackingHours} />*/}
                        <Charges Charge={EstimateDetails.WarehouseHandling}/>
                        <Charges Charge={EstimateDetails.StorageFee}/>
                        <Charges Charge={EstimateDetails.FuelSurcharge}/>
                        {EstimateDetails.Discount && EstimateDetails.Discount.Value &&
                        !EstimateDetails.Discount.Value.toString().includes('%') && (
                            <Charges Charge={EstimateDetails.Discount} type="Discount" />
                        )}
                        {EstimateDetails.EstimateAdditionalCharges.map((additional_charge, key) => {
                            return (<Charges Charge={additional_charge} key={key}/>)
                        })}
                        {EstimateDetails.Discount && EstimateDetails.Discount.Value &&
                        EstimateDetails.Discount.Value.toString().includes('%') && (
                            <Charges Charge={EstimateDetails.Discount} type="Discount" />
                        )}
                        <Charges Charge={EstimateDetails.AutomaticValuation}/>
                        {/*<Charges Charge={EstimateDetails.TotalEstPrice}/>*/}
                        {/*<Charges Charge={EstimateDetails.NotToExceedTotal}/>*/}
                        <Charges Charge={EstimateDetails.PercentageText}/>
                        {/*{ EstimateDetails.EstimateType ==="hourly" && !EstimateDetails.ShowPriceRange?*/}
                        {/*<Charges Charge={EstimateDetails.EstPriceRange}/> : ""}*/}
                        </tbody>
                    </table>
                </li>
                <li>
                    <div className="row ">
                        <div className="col-sm-6">
                            {SignPresent === true ?
                                <div className={loading == 'yes' ? "estimated-date-new" : "estimated-date"}>
                                    {image ?
                                        <>
                                            {isAdmin ?
                                                <div className='btn client_portal_sign'
                                                     onClick={() =>
                                                         DeleteSign(jobDetails.ClientPortalSignId,
                                                             RecordsController, setSignPresent(false))}>
                                                    X
                                                </div> : <></>
                                            }
                                            {image}
                                            <div className="estimated-date2">
                                                {jobDetails.ClientPortalSignatureUpdatedAt}
                                            </div>
                                        </> : loading == "yes" ? loadingImage : ""
                                    }
                                </div> : <></>}
                        </div>
                        <div className="col-sm-6">
                            <div className="estimated-range">
                                {EstimateDetails.EstimateType !== "guaranteed" && EstimateDetails.ShowTotalEstPrice ?
                                    <span
                                        style={{float: "right"}}>{EstimateDetails.TotalEstPrice.Name} = {EstimateDetails.TotalEstPrice.Currency}
                                        {EstimateDetails.TotalEstPrice.Value}</span> :
                                    EstimateDetails.EstimateType === "guaranteed" ?
                                        <span
                                            style={{float: "right"}}>{EstimateDetails.PriceVerbiage.Name} = {EstimateDetails.PriceVerbiage.Currency}
                                            {EstimateDetails.PriceVerbiage.Value}</span> : <></>
                                }
                                {
                                    EstimateDetails.EstimateType === "not_to_exceed" ?
                                        <span
                                            style={{float: "right"}}>{EstimateDetails.NotToExceedTotal.Name} = {EstimateDetails.NotToExceedTotal.Currency}
                                            {EstimateDetails.NotToExceedTotal.Value}</span> : <></>
                                }
                                {EstimateDetails.EstimateType === "hourly" && !EstimateDetails.ShowPriceRange ?
                                    <h6 style={{float: "right"}}>Estimated Price Range
                                        = {EstimateDetails.EstPriceRange.Value}</h6> : <></>}
                            </div>
                        </div>
                    </div>
                </li>
                {signText}
            </>
        )
    }
}

const Charges = (props) => {
    return (
        <>
            {props.Charge.Show ? <tr>
                <td id="td-cls" data-label="Charge Description">{props.Charge.Name === undefined ? props.Charge.Name : props.Charge.Name.toUpperCase()}</td>
                {props.ChargeRate !== undefined && props.ChargeRate.Value !== '0.00' ?
                    <td id="td-cls" data-label="Charge Rate"><span>{props.Charge.Currency}{props.ChargeRate.Value}/hour</span></td>
                    :
                    props.Charge.ExtraValue ?
                        <td id="td-cls" data-label="Charge Rate"><span>{props.Charge.ExtraValue}</span></td> :
                        <td id="td-cls" data-label="Charge Rate"><span>-</span></td>}

                {props.type === "Discount" ?
                    <td id="td-cls" data-label="Charge Cost" style={{color: "red"}}>- {props.Charge.Currency}{props.Charge.Value}
                    </td>
                    : props.Charge.Value === "-" ? <td id="td-cls" data-label="Charge Cost">
                        {props.Charge.Value}</td> :<td id="td-cls" data-label="Charge Cost">
                        {props.Charge.Currency}{props.Charge.Value}</td>
                }
            </tr> : <></>}
        </>
    )
}

export default EstimateJobCharges;